// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23fUI","badges":"styles_badges__1SmwS"};